module.exports = __webpack_public_path__ + "media/images/ui-icons_d7a639_256x240-1692df2178768cf109b9017ab33c3e19.png";